import { LocaleSwitcher } from './index';
import { useLocaleSwitcher } from 'hooks/use-locale-switcher';
import type { TenantId } from 'tenants/types/tenant';

type LocaleSwitcherContainerProps = {
  tenantId: TenantId;
};

export function LocaleSwitcherContainer({ tenantId }: LocaleSwitcherContainerProps) {
  const { 
    isEnabled, 
    isReady, 
    currentLocale, 
    localeOptions, 
    changeLocale, 
  } = useLocaleSwitcher(tenantId);

  return (
    <LocaleSwitcher
      shouldRender={isEnabled && isReady}
      currentLocale={currentLocale}
      localeOptions={localeOptions}
      changeLocale={changeLocale}
    />
  );
} 